import * as React from "react"
import { useLocation } from '@reach/router'
import { imgSize } from '~/utils/helpers'


export const Seo = ({ title, description, image, url=false, children, hide=false }) => {
  const location = useLocation();

  let tagline = process.env.NODE_ENV === "development" ? ' - Staging' : '- Modern American Classics'
  let title_text = `${title}${title.includes('Buck Mason') ? '' : ' - Buck Mason'}${tagline}`
  let default_desc = `Inspired by laid back California ethos of easy living, quality, & simplicity, 
                      Buck Mason is a modern American brand that makes fashion less complicated.`
  let defalt_img = 'https://cdn.shopify.com/s/files/1/0123/5065/2473/files/chicago_1_0d30a8f6-9b69-4702-9afe-2d58adbfcbf7.jpg?v=1696020535'
  
  let meta_img = image ? imgSize(image, 1024) : defalt_img
  let meta_desc = description ? description : default_desc

  const canonical = url ? `https://www.buckmason.com${url}` : location.href


  return (
    <>
      {hide && (
        <meta name="robots" content="noindex" />
      )}
      <title>{title_text}</title>
      <meta property="og:url" content={location.href} />
      <meta property="og:title" content={title_text} />
      <meta name="twitter:title" content={title_text} />
      <link rel="canonical" href={canonical} />

      <meta name="description" content={meta_desc} />
      <meta property="og:description" content={meta_desc} />
      <meta name="twitter:description" content={meta_desc} />

      <meta property="og:image" content={meta_img.replace('https:','http:')} />
      <meta property="og:image:secure_url" content={meta_img} />
      <meta name="twitter:image" content={meta_img.replace('https:','http:')} />
      {children}
    </>
  )
}
